import { render } from "./BlogDark.vue?vue&type=template&id=9842bf8e"
import script from "./BlogDark.vue?vue&type=script&lang=js"
export * from "./BlogDark.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__